module.exports = __webpack_public_path__ + "static/img/anxun33.96248241.png";